import { memo } from 'react';
import { useMount } from 'react-use';

export type EditInCanvasSubmenuShownTrackerProps = {
  onShown: () => void;
};

/** Menu primitives mount sub options only while the submenu shows, so mounting this means it was shown. */
export const EditInCanvasSubmenuShownTracker = memo(({ onShown }: EditInCanvasSubmenuShownTrackerProps) => {
  useMount(onShown);

  return null;
});

EditInCanvasSubmenuShownTracker.displayName = 'EditInCanvasSubmenuShownTracker';
